import { create } from 'zustand';

const useUiStateStore = create((set) => ({
    isRegistPopupOpen: false, //이용권 등록 팝업
    isSubmitOkPopupOpen: false, // 이용권 등록 OK 팝업
    isPcTooltipOpen: false, // cgm, cardiogram
    isCheckupCardPopupOpen: false, // mo checkup card
    
    setRegistPopupOpen: (isOpen) => set(() => {
        return { isRegistPopupOpen: isOpen }
    }),
    setSubmitOkPopupOpen: (isOpen) => set(() => {
        return { isSubmitOkPopupOpen: isOpen }
    }),
    setPcTooltipOpen: (isOpen) => set(() => {
        return { isPcTooltipOpen: isOpen }
    }),
    setCheckupCardPopupOpen: (isOpen) => set(() => {
        return { isCheckupCardPopupOpen: isOpen }
    }),
}));

export default useUiStateStore;